// extracted by mini-css-extract-plugin
export default {"tiptapContent":"TiptapField_tiptapContent__jVLuK","tiptapClassContentProseMirror":"TiptapField_tiptapClassContentProseMirror__PtIXP","invalid":"TiptapField_invalid__-AjGz"};